<template>
  <div>
    <div class="header">
      <div class="header-nav">
        <div class="header-contact">
          <div class="logo">
            <router-link to="/" title="北京明世继元招标有限公司">
              <img src="@/assets/images/left-logo.png" alt="">
              <p>明世继元</p>
            </router-link>
            <ul class="nav-box">
              <router-link to="/" tag="li" class="active">网站首页</router-link>
              <router-link to="/info" tag="li">
                信息公告
                <div class="child">
                  <router-link to="/policy">政策法规</router-link>
                </div>
              </router-link>
              <router-link to="/auction/announcement" tag="li">
                拍卖中心
                <div class="child">
                  <router-link to="/auction/announcement">拍卖公告</router-link>
                  <router-link to="/auction/display">拍品展示</router-link>
                  <router-link to="/auction/other">其他链接</router-link>
                </div>
              </router-link>
              <router-link to="/company" tag="li">
                关于我们
                <div class="child">
                  <router-link to="/company">公司简介</router-link>
                  <router-link to="/honor">公司荣誉</router-link>
                </div>
              </router-link>
              <router-link to="/contact" tag="li">联系我们</router-link>
              <router-link to="/recruit" tag="li">职位招聘</router-link>
            </ul>
            <div class="right-logo">
              <img src="@/assets/images/right-logo.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="banner">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(banner,idx) in bannerList" :key="idx" style="cursor: pointer;">
            <div class="banner-box" @click="goDetail(banner.newsContentLink, banner.templateRecordUrl, banner.newsContentType, banner.newsContentContent)">
              <img :src="requestUrl + '/news/route/file/downloadfile/true/' + banner.newsContentCoverList" alt="">
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <Intro :introContent="introContent" :dynamicSlideList="dynamicSlideList"></Intro>
    <Bidding></Bidding>
    <CompanyInfo :honorIntro="honorIntro" :policyIntro="policyIntro" :recruitIntro="recruitIntro"></CompanyInfo>
    <div class="about-link">
      <div class="link-title">相关链接</div>
      <div class="link">
        <a href="http://www.ccgp.gov.cn/" target="_blank">中国政府采购网</a>
        <a href="http://www.ccgp-beijing.gov.cn/" target="_blank">北京市政府采购网</a>
        <a href="http://www.ccgp-neimenggu.gov.cn/" target="_blank">内蒙古自治区政府采购网</a>
        <a href="http://zbgg.nmgztb.com.cn/" target="_blank">内蒙古招标投标公共服务平台</a>
        <a href="http://zfcg.tongliao.gov.cn/" target="_blank">通辽市政府采购网</a>
        <a href="http://www.yngp.com/" target="_blank">云南省政府采购网</a>
      </div>
    </div>
<!--    <Contact></Contact>-->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/assets/components/Header'
import Footer from '@/assets/components/Footer'
import Banner from './components/Banner'
import Intro from './components/Intro'
import Bidding from './components/Bidding'
import CompanyInfo from './components/CompanyInfo'
import Contact from './components/Contact'
import url from '@/assets/public/url'
import axios from 'axios'
export default {
  name: "Index",
  components: {
    Header,
    Banner,
    Intro,
    Bidding,
    CompanyInfo,
    Contact,
    Footer
  },
  data() {
    return {
      requestUrl: url.url,
      biddingList: [],
      winBidList: [],
      bannerList: [],
      honorIntro: {},
      policyIntro: {},
      recruitIntro: {},
      introContent: '',
      swiperOptions: {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: 3000
      },
      dynamicSlideList: []
    }
  },
  methods: {
    // 获取轮播
    getBanner: function () {
      var self = this
      var info = {
        page: 1,
        rows: 5,
        newsDirectoriesId: '3814f671-3de5-4493-9d66-30ce6941cc54'
      }
      axios.get(self.requestUrl + '/news/app/newscontent/listpagenewscontentrelease', {
        params: info
      }).then(function (res) {
        for (let i = 0 ; i < res.data.rows.length; i++) {
          res.data.rows[i].newsContentCoverList = res.data.rows[i].newsContentCoverList[0].contentCoverId
        }
        self.bannerList = res.data.rows
      })
    },
    goDetail: function (link, url, type, outlink) {
      if (type === '6') {
        window.open(outlink)
      } else {
        window.location.href = this.requestUrl + '/' +url
      }
    },
    // 获取版块介绍
    getHonorIntro: function () {
      var self = this
      axios.get(self.requestUrl + '/news/app/newsdirectories/getnewsdirectoriesbyidrelease/a6674c61-ff68-4364-a9c4-61af3e4a3b58').then(function (res) {
        console.log(res.data)
        self.honorIntro = {
          text: res.data.directoriesDescription,
          cover: res.data.directoriesPhoto
        }
      })
    },
    // 获取版块介绍
    getPolicyIntro: function () {
      var self = this
      axios.get(self.requestUrl + '/news/app/newsdirectories/getnewsdirectoriesbyidrelease/0d9f6316-5aec-471c-bc25-5c661f5aa363').then(function (res) {
        self.policyIntro = {
          text: res.data.directoriesDescription,
          cover: res.data.directoriesPhoto
        }
      })
    },
    // 获取版块介绍
    getRecruitIntro: function () {
      var self = this
      axios.get(self.requestUrl + '/news/app/newsdirectories/getnewsdirectoriesbyidrelease/dffd3376-9f78-44bb-afa5-4b41b1b8a4c5').then(function (res) {
        self.recruitIntro = {
          text: res.data.directoriesDescription,
          cover: res.data.directoriesPhoto
        }
      })
    },
    // 获取公司介绍
    getIntro: function () {
      var self = this
      var info = {
        page: 1,
        rows: 10,
        newsDirectoriesId: 'a2c3ed88-5ea4-4a60-8af6-f25733e6886f',
      }
      axios.get(self.requestUrl + '/news/app/newscontent/listpagenewscontentrelease', {
        params: info
      }).then(function (res) {
        self.getIntroDetail(res.data.rows[0].newsContentId)
      })
    },
    getIntroDetail: function (id) {
      var self = this
      axios.get(self.requestUrl + '/news/app/newscontent/getnewscontentbyidrelease/' + id).then(function (res) {
        self.introContent = res.data.newsContentContent
        self.isLoading = false
      })
    },
    getDynamicSlide: function () {
      var self = this
      var info = {
        page: 1,
        rows: 5,
        newsDirectoriesId: 'f93f9bfc-2fac-4bf4-aacf-2d737f31bce1'
      }
      axios.get(self.requestUrl + '/news/app/newscontent/listpagenewscontentrelease', {
        params: info
      }).then(function (res) {
        for (let i = 0 ; i < res.data.rows.length; i++) {
          res.data.rows[i].newsContentCoverList = res.data.rows[i].newsContentCoverList[0].contentCoverId
        }
        self.dynamicSlideList = res.data.rows
      })
    }
  },
  mounted() {
    this.getBanner()
    this.getHonorIntro()
    this.getPolicyIntro()
    this.getRecruitIntro()
    this.getIntro()
    this.getDynamicSlide()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~styles/public.styl"
.header
  //padding 10px 0
  height 650px
  overflow hidden
  position relative
  .contact
    padding 15px 0
    width 1200px
    margin 0 auto
    span
      font-size 12px
      display inline-block
      color #fff
      font-style oblique
      padding 0 15px 0 20px
      &.phone
        background url("~@/assets/images/phone.png") no-repeat left center
        border-right 1px solid #2c367e
        margin-right 10px
      &.email
        background url("~@/assets/images/email.png") no-repeat left center
  .header-nav
    position fixed
    top 0
    left 0
    right 0
    padding 5px 0
    background rgba(255,255,255,0.8)
    //background rgb(255,255,255)
    z-index 1000
    .header-contact
      width 1200px
      margin 0 auto
    .logo
      width 1200px
      margin 0 auto
      &:after
        content ''
        display block
        clear both
      a
        display block
        float left
        text-align center
        img
          width 70px
          height 52px
        p
          color #4c4c4c
          font-size 16px
          font-weight 900
      .nav-box
        float left
        margin-left 200px
        margin-top 5px
        &:after
          content ''
          display block
          clear both
        li
          float left
          line-height 44px
          font-size 16px
          color #333
          margin-right 75px
          cursor pointer
          position relative
          border-bottom 3px solid #b2b2b2
          &:last-child
            margin-right 0
          &.active, &:hover
            font-weight bold
            color $main-blue
            border-bottom 3px solid $main-red
          &:hover
            a
              font-weight normal
            .child
              display block
          .child
            position absolute
            top 100%
            left -13px
            padding 0 10px
            width 110%
            box-shadow 0 0 10px #EEE
            display none
            background #fff
            a
              display block
              line-height 40px
              font-size 16px
              color #333
              text-align center
              &:hover
                font-weight bold
                color $main-blue
      .right-logo
        float right
        margin-top 5px
        img
          width 80px
          height 70px
  .banner
    position absolute
    height 650px
    top 0
    left 0
    right 0
    bottom 0
    z-index 2
    .swiper-container
      height 100% !important
    .banner-box
      position relative
      width 100%
      height 100%
      overflow hidden
      img
        position absolute
        top 0
        left 50%
        transform translate(-50%, 0)
        //width 100%
        height 650px
.nav
  background #f9cd1b
  .nav-container
    width 1200px
    margin 0 auto
    ul
      &:after
        display block
        content ''
        clear both
      li
        width 65px
        float left
        height 40px
        line-height 40px
        cursor pointer
        font-size 16px
        color #2c367e
        margin-right 160px
        position relative
        border-bottom 2px solid transparent
        &:last-child
          margin-right 0
        &.active, &:hover
          font-weight bold
          border-bottom 2px solid $main-red
        &:hover
          a
            font-weight normal
          .child
            display block
        .child
          position absolute
          top 100%
          left -10px
          box-shadow 0 0 10px #EEE
          padding 0 10px
          width 110%
          display none
          a
            display block
            position relative
            font-size 16px
            color #2c367e
            line-height 40px
            &:hover
              font-weight bold
.about-link
  width 1200px
  margin 20px auto 40px
  .link-title
    font-size 20px
    color #333
    padding-bottom 10px
    border-bottom 1px solid #EEE
  .link
    margin-top 10px
    a
      display inline-block
      margin-right 10px
      color #333
      &:hover
        color #2c367e
</style>



// WEBPACK FOOTER //
// src/pages/Index/Index.vue